module.exports = __webpack_public_path__ + "img/cover.51518c57.jpg";